// extracted by mini-css-extract-plugin
export default {"items":"List_items__KJG7R","card":"List_card__gDjJ0","listItem":"List_listItem__bK87o"};